import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d78ac108"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-container" }
const _hoisted_2 = { class: "table table-hover table-v2" }
const _hoisted_3 = { class: "py-3" }
const _hoisted_4 = { class: "categories-tree-item-content d-flex align-items-center" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-1 mb-1" }, "chevron_right", -1))
const _hoisted_7 = { class: "fw-600 fs-5" }
const _hoisted_8 = {
  key: 1,
  class: "name m-0 ps-4 fw-600 fs-5"
}
const _hoisted_9 = ["colspan"]
const _hoisted_10 = { class: "button-container ps-0 d-flex align-items-center" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "save", -1))
const _hoisted_13 = {
  key: 0,
  class: "ms-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_RenameDPSubCategory = _resolveComponent("RenameDPSubCategory")!
  const _component_AutoSaveFeedback = _resolveComponent("AutoSaveFeedback")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('renameDPSubcategories'),
        mb: 4
      }, null, 8, ["title"]),
      _createVNode(_component_AlertError2, {
        error: _ctx.pageUI.getError()
      }, null, 8, ["error"]),
      (!_ctx.pageUI.getIsReady())
        ? (_openBlock(), _createBlock(_component_base_spinner, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_dp_form, {
        as: "form",
        novalidate: "",
        onSubmit: _ctx.submitData
      }, {
        default: _withCtx(({ errors }) => [
          (_ctx.pageUI.isReady())
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "tree-with-button",
                style: _normalizeStyle({ height: _ctx.dynamicHeight })
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("table", _hoisted_2, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('category')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allLanguages, (language) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: language,
                            style: {"width":"30%"}
                          }, _toDisplayString(_ctx.$t('customerName')) + " (" + _toDisplayString(language.toUpperCase()) + ") ", 1))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryTree?.subcategories, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: item.code
                        }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_3, [
                              _createElementVNode("div", _hoisted_4, [
                                (item.subcategories?.length)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      role: "button",
                                      onClick: ($event: any) => (_ctx.toggleOpen(item.code)),
                                      class: _normalizeClass([{ open: _ctx.isOpen(item.code) }, "name d-flex align-items-center text-decoration-none lh-1"])
                                    }, [
                                      _hoisted_6,
                                      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getCustomItemName(item)), 1)
                                    ], 10, _hoisted_5))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_8, "  " + _toDisplayString(_ctx.getCustomItemName(item)), 1))
                              ])
                            ]),
                            _createElementVNode("td", {
                              colspan: _ctx.allLanguages.length
                            }, null, 8, _hoisted_9)
                          ]),
                          (_ctx.isOpen(item.code) && item.subcategories?.length)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.subcategories, (subCategory) => {
                                return (_openBlock(), _createBlock(_component_RenameDPSubCategory, {
                                  key: subCategory.code,
                                  errors: errors,
                                  "all-languages": _ctx.allLanguages,
                                  language: _ctx.language,
                                  level: 2,
                                  "category-names": _ctx.customNamesMap,
                                  "categories-tree-item": subCategory,
                                  open: _ctx.open,
                                  onToggleOpen: _ctx.toggleOpen,
                                  onNameChanged: _ctx.onNameChanged
                                }, null, 8, ["errors", "all-languages", "language", "category-names", "categories-tree-item", "open", "onToggleOpen", "onNameChanged"]))
                              }), 128))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary",
                    disabled: !_ctx.hasChanges
                  }, [
                    _hoisted_12,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('save')), 1)
                  ], 8, _hoisted_11),
                  (_ctx.autoSaveFeedbackStatus !== _ctx.AutoSaveFeedbackStatusEnum.NONE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(_component_AutoSaveFeedback, { status: _ctx.autoSaveFeedbackStatus }, null, 8, ["status"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 4))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }))
}